import { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';

import {
    ReportParameterContainer,
    Subtitle,
    Line,
    SearchContainer,
    InputContainer,
    SearchButtonsContainer
} from './styles';
import DropDownIcon from '../../assets/drop_down_icon.png';
import DropUpIcon from '../../assets/drop_up_icon.png';
import FilterIcon from '../../assets/filter_icon.png';
import ModalCancel from '../Modal/Cancel';
import ModalWarn from '../Modal/Warn/index';
import { SelectContainer } from '../../Reports/styles';
import Select, { components } from 'react-select';
import { profile } from '../../constants';

export default function ReportInputDataInterval(props) {
    const [modalCancel, setModalCancel] = useState(false);
    const { handleSubmit } = useForm();

    const [organOptions, setOrganOptions] = useState([]);
    const [selectedOrgan, setSelectedOrgan] = useState({ value: "", label: "Selecione a rede de atendimento" });
    
    const user = JSON.parse(localStorage.getItem('user'));
    const perfil = user.perfil;
    const url = new URL(window.location.href);
    const pathname = url.pathname;

    useEffect(() => {
        async function loadOrganOptions() {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': user ? user.token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_usuario: user ? user.cpf_atendente : ""
                }),
            };
            
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/consultaOrgaoGestorOrgao`, requestOptions).then(
                function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        var organList = [];
                        data.map((organ) => (organList.push({ value: organ.CODIGO_ORGAO, label: organ.NOME_REDE_ATENDIMENTO })));
                        setOrganOptions(organList);
                    });
                } else {
                    console.log('Error request to /gestao/consultaOrgaoGestorOrgao');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }
        if (perfil === profile.gestorSistema && pathname === "/relAtendimentosPorAtendente") {
            loadOrganOptions();
        }        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const SelectStyles = {
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            borderWidth: state.isFocused ? 2.5 : 1,
            borderColor: state.isFocused ? '#E60000' : '#888',
            '&:hover': { backgroundColor: '#C5D4EB' },
            marginTop: 4,
        }),
    }

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                {props.selectProps.menuIsOpen ? <img src={DropUpIcon} alt="upicon" /> : <img src={DropDownIcon} alt="downicon" />}
            </components.DropdownIndicator>
        );
    };

    const IndicatorSeparator = ({ innerProps }) => <span style={{}} {...innerProps} />;
    return (
        <>
            <ReportParameterContainer>
                <ModalCancel
                    id="modalcancelalert"
                    appear={modalCancel}
                    text={"Deseja retornar para a página anterior?"}
                    actionButton1={() => setModalCancel(false)}
                    actionButton2={() => props.history.push("/pesquisarcidadao")}
                />
                <ModalWarn
                    id="modalconfirmalert"
                    appear={props.modalError}
                    text={props.messageError}
                    textButton2='Ok'
                    actionButton2={() => props.setModalError(false)}
                />
                <Subtitle>
                    <img
                        src={FilterIcon}
                        alt="filterIcon"
                    />
                    <label> Período </label>
                    <Line />
                </Subtitle>
                <form onSubmit={handleSubmit(() => props.onSubmitSearch())}>
                    <SearchContainer>
                        <InputContainer>
                            <div className="br-input">
                                <label htmlFor="dt_inicio">Data de início</label>
                                <input
                                    id="dateandtime-input"
                                    name="dt_inicio"
                                    type="date"
                                    data-input="data-input"
                                    placeholder="dd/mm/aaaa"
                                    defaultValue={props.dataInterval.dt_inicio}
                                    onChange={e => { props.setDataInterval({ ...props.dataInterval, dt_inicio: e.target.value }); props.setResult() }}

                                />
                            </div>
                        </InputContainer>
                        <InputContainer>
                            <div className="br-input">
                                <label htmlFor="dt_inicio">Data final</label>
                                <input
                                    id="dateandtime-input"
                                    name="dt_fim"
                                    type="date"
                                    data-input="data-input"
                                    placeholder="dd/mm/aaaa"
                                    defaultValue={props.dataInterval.dt_fim}
                                    onChange={e => { props.setDataInterval({ ...props.dataInterval, dt_fim: e.target.value }); props.setResult() }}
                                />
                            </div>
                        </InputContainer>
                        {perfil === profile.gestorSistema 
                            && pathname === "/relAtendimentosPorAtendente" &&
                            <InputContainer>
                                <label htmlFor="organ">Rede de atendimento</label>
                                <select
                                    className="br-select"
                                    style={{ width: '100%', borderRadius: '6px', border: '1px solid #888' }}
                                    name="organ"
                                    id="organ"
                                    value={selectedOrgan.value}
                                    required={selectedOrgan.value !== ""}
                                    onChange={e => { 
                                        const selectedOption = organOptions.find(option => option.value === e.target.value) || { value: "", label: "Selecione" };
                                        setSelectedOrgan(selectedOption); 
                                        props.setDataInterval({ ...props.dataInterval, organ: e.target.value });
                                        props.setResult();
                                    }}
                                >
                                    <option value="">Selecione</option>
                                    {organOptions && organOptions.length > 0 && 
                                        organOptions.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))
                                    }
                                </select>
                            </InputContainer>
                        }
                        {props.agrupadores &&
                            <SelectContainer>
                                <label>Agrupador</label>
                                <Select
                                    onChange={a => { props.setAgrupador(a.value); props.setResult() }}
                                    options={props.agrupadores}
                                    values={props.agrupadores}
                                    defaultValue={props.agrupadores[0]}
                                    styles={SelectStyles}
                                    theme={theme => ({
                                        ...theme,
                                        borderRadius: 6,
                                        colors: {
                                            ...theme.colors,
                                            primary25: '#CCCCCC',
                                            primary: '#1351B4'
                                        },
                                    })}
                                    components={{ DropdownIndicator, IndicatorSeparator }}
                                />
                            </SelectContainer>
                        }
                        <SearchButtonsContainer>
                            <button className="br-button secundary" type="button"
                                onClick={() => setModalCancel(true)}>
                                Voltar
                            </button>
                            <button className="br-button terciary" type="button" disabled={!props.result?.length}
                                onClick={() => window.print()}>
                                Imprimir
                            </button>
                            <button className={props.loadingReport ? "br-button primary loading" : "br-button primary"} type="submit">
                                Gerar relatório
                            </button>
                        </SearchButtonsContainer>
                    </SearchContainer>

                    <Subtitle>
                        <Line />
                    </Subtitle>
                </form>
            </ReportParameterContainer>
        </>
    );
}